import { Injectable } from '@angular/core';
import { Timezone, TimezoneFormData } from '../models/timezone.model';
import { BaseCrudService } from './base-crud.service';

@Injectable({
  providedIn: 'root'
})
export class TimezonesService extends BaseCrudService<Timezone, TimezoneFormData> {
  protected endpoint = 'timezones';
  protected override useMock = false;

  protected mockData: Timezone[] = [
    {
      id: 1,
      name: 'America/Mexico_City',
      gmt_offset: '-06:00',
      description: 'Hora del Centro',
      is_active: true
    },
    {
      id: 2,
      name: 'America/Monterrey',
      gmt_offset: '-06:00',
      description: 'Hora del Noreste',
      is_active: true
    },
    {
      id: 3,
      name: 'America/Cancun',
      gmt_offset: '-05:00',
      description: 'Hora de Quintana Roo',
      is_active: true
    },
    {
      id: 4,
      name: 'America/Chihuahua',
      gmt_offset: '-07:00',
      description: 'Hora del Noroeste',
      is_active: true
    },
    {
      id: 5,
      name: 'America/Merida',
      gmt_offset: '-06:00',
      description: 'Hora de Yucatán',
      is_active: true
    }
  ];
}
